import { render, staticRenderFns } from "./listByParentDialog.vue?vue&type=template&id=706ad8c6&scoped=true"
import script from "./listByParentDialog.vue?vue&type=script&lang=js"
export * from "./listByParentDialog.vue?vue&type=script&lang=js"
import style0 from "./listByParentDialog.vue?vue&type=style&index=0&id=706ad8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706ad8c6",
  null
  
)

export default component.exports